module.exports = __webpack_public_path__ + "img/ic-salissures.0d27fdf2.svg";